module.exports = __webpack_public_path__ + "assets/img/startup-time-comparison.3bbc7c54.jpg";